import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { MixingChildTicketDataModel } from 'shared/models';
import { PastePreparationService } from '../../paste-preparation/PastePreparationService';
import { TenantContextService } from 'shared/core';
import { partLabel } from '../../workplan-list/vessel-split.util';

@Component({
  selector: 'app-mixing-child-ticket-print',
  templateUrl: './mixing-child-ticket-print.component.html',
  styleUrls: ['./mixing-child-ticket-print.component.less'],
  standalone: false,
})
export class MixingChildTicketPrintComponent implements OnInit, OnDestroy {
  data: MixingChildTicketDataModel | null = null;
  isLoading = true;
  masterMixBatchNumber = '';
  mixingChildTicketNumber = '';

  private route$ = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private pastePreparationService: PastePreparationService,
    private tenantContext: TenantContextService,
  ) {}

  ngOnInit(): void {
    this.route$ = this.route.params.subscribe((p: Params) => {
      this.masterMixBatchNumber = p['masterMixBatchNumber'];
      this.mixingChildTicketNumber = p['mixingChildTicketNumber'];
      this.load();
    });
  }

  ngOnDestroy(): void {
    this.route$.unsubscribe();
  }

  private load(): void {
    if (!this.masterMixBatchNumber || !this.mixingChildTicketNumber) {
      this.isLoading = false;
      return;
    }
    this.pastePreparationService
      .getMixingChildTicket(this.masterMixBatchNumber, this.mixingChildTicketNumber)
      .subscribe({
        next: (d) => {
          this.data = d;
          this.isLoading = false;
          // A fresh print tab may still be loading the company details for the header.
          this.tenantContext.whenCompanyInfoReady().then(() => setTimeout(() => window.print(), 500));
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  get mixingLabel(): string {
    return this.data ? partLabel(this.data.MixingName, this.data.SubBatchSequence, this.data.SubBatchCount) : '';
  }
}
